import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBCPLimits } from '../../hooks/useBCPLimits';
import BCPLimitsModal from './BCPLimitsModal';

interface BCPCreationButtonProps {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const BCPCreationButton: React.FC<BCPCreationButtonProps> = ({
  className = "",
  children,
  onClick
}) => {
  const navigate = useNavigate();
  const { limits, loading: limitsLoading, canCreateBCP } = useBCPLimits();
  const [showLimitsModal, setShowLimitsModal] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    // If still loading, don't do anything
    if (limitsLoading) {
      return;
    }

    // If user can't create BCP, show modal instead of navigating
    if (!canCreateBCP) {
      setShowLimitsModal(true);
      return; // Don't navigate if limits are reached
    }

    // Only navigate if user can create BCP - explicit navigation
    navigate('/bcp/new');
  };

  return (
    <>
      <button
        type="button"
        className={`${className} ${limitsLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
        onClick={handleClick}
        disabled={limitsLoading}
      >
        {limitsLoading ? (
          <div className="flex items-center">
            <div className="mr-2 w-4 h-4 rounded-full border-b-2 border-current animate-spin"></div>
            Checking limits...
          </div>
        ) : (
          children
        )}
      </button>

      <BCPLimitsModal
        isOpen={showLimitsModal}
        onClose={() => setShowLimitsModal(false)}
        limits={limits}
        loading={limitsLoading}
        onUpgrade={() => {
          setShowLimitsModal(false);
          // Navigate to subscription management
          window.location.href = '/subscription';
        }}
      />
    </>
  );
};

export default BCPCreationButton;
